export default __webpack_public_path__ + "static/img/image2.6476fe7.png";